import { Divisor } from '@terraware/web-components';

export default Divisor;
